import createSelectors from './createSelectors';
import TextMessageTemplate from '../models/TextMessageTemplate';

const Select = createSelectors(TextMessageTemplate, {});

export default Select;
